import * as Immutable from "immutable";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import PaginationURL from "util/PaginationURL";
import Team from "../../security/logic/Team";
const apiPrefix = "/plugins/org.graylog.plugins.security";
const ApiRoutes = {
  AuthenticationController: {
    loadTeamsPaginated: (authBackendId) => ({
      url: `${apiPrefix}/team-sync/services/${authBackendId}/backend/teams`
    }),
    triggerTeamSync: (backendId) => ({ url: `${apiPrefix}/team-sync/trigger/${backendId}` })
  }
};
export const SYNCED_TEAMS_QUERY_KEY = ["authentication", "synced-teams"];
export const loadSyncedTeamsPaginated = (authBackendId, { page: newPage, perPage: newPerPage, query: newQuery }) => {
  const url = PaginationURL(
    ApiRoutes.AuthenticationController.loadTeamsPaginated(authBackendId).url,
    newPage,
    newPerPage,
    newQuery
  );
  return fetch("GET", qualifyUrl(url)).then(
    ({ teams, context, page, per_page: perPage, query, count, total }) => ({
      list: Immutable.List(teams.map((user) => Team.fromJSON(user))),
      context: {
        roles: Immutable.Map(context == null ? void 0 : context.roles),
        users: Immutable.Map(context == null ? void 0 : context.users)
      },
      pagination: {
        page,
        perPage,
        query,
        count,
        total
      }
    })
  );
};
export const useSyncedTeamsPaginated = (authBackendId, pagination) => useQuery({
  queryKey: [...SYNCED_TEAMS_QUERY_KEY, authBackendId, pagination],
  queryFn: () => loadSyncedTeamsPaginated(authBackendId, pagination),
  placeholderData: keepPreviousData
});
export const triggerTeamSync = (backendId, _backendTitle) => fetch("POST", qualifyUrl(ApiRoutes.AuthenticationController.triggerTeamSync(backendId).url)).then(
  ({
    success,
    message,
    errors,
    created_teams: createdTeams,
    deleted_teams: deletedTeams,
    updated_teams: updatedTeams
  }) => ({
    success,
    message,
    errors,
    createdTeams,
    deletedTeams,
    updatedTeams
  })
);
